@use "@fukuri-admins/ui/layout" as *;

.body {
  @include body;
}
